import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Fingerprint, Lock, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      nav("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-monk-bg grid-noise flex items-center justify-center px-4">
      <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(circle at 30% 20%, rgba(0,122,255,0.08), transparent 45%)" }} />
      <div className="relative w-full max-w-md">
        <div className="mb-8">
          <div className="w-12 h-12 rounded-md bg-monk-blue/15 border border-monk-blue/40 flex items-center justify-center mb-5">
            <Fingerprint className="w-6 h-6 text-monk-blue" />
          </div>
          <div className="overline mb-2">Forensic Intelligence Platform</div>
          <h1 className="font-heading font-900 text-5xl tracking-tighter leading-none">MONK</h1>
          <p className="text-neutral-500 text-sm mt-3 max-w-sm">A 32-engine forensic intelligence system. Authorized personnel only.</p>
        </div>

        <form onSubmit={submit} className="bg-monk-panel border border-white/10 rounded-md p-6 space-y-4" data-testid="login-form">
          <div>
            <label className="overline block mb-2">Officer Email</label>
            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-black border border-white/15 rounded-sm px-3 py-2.5 text-sm focus:border-monk-blue focus:outline-none transition-colors"
              placeholder="officer@monk.gov" />
          </div>
          <div>
            <label className="overline block mb-2">Credential</label>
            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-black border border-white/15 rounded-sm px-3 py-2.5 text-sm focus:border-monk-blue focus:outline-none transition-colors"
              placeholder="••••••••" />
          </div>
          {error && <div data-testid="login-error" className="text-monk-critical text-sm bg-monk-critical/10 border border-monk-critical/30 rounded-sm px-3 py-2">{error}</div>}
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-monk-blue text-white font-medium rounded-sm py-2.5 text-sm flex items-center justify-center gap-2 hover:bg-monk-blue/90 disabled:opacity-60 transition-colors">
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Authenticating…</> : <><Lock className="w-4 h-4" /> Enter Command Center</>}
          </button>
        </form>

        <div className="mt-4 text-[11px] text-neutral-600 font-mono leading-relaxed">
          CHIEF · mkk09m@gmail.com<br />
          DETECTIVE · detective@monk.gov
        </div>
      </div>
    </div>
  );
}
